import React from 'react';
import {ISetAside} from "../../../api/Analytics/Analytics.types";
import BaseTopGraph from "./Contracts.graphs.baseTopGraph";

interface Props {
    data:ISetAside[]
}

function ContractsTopSetAsideGraph({ data }:Props){

    function serializeData() {
        return data.map(setAside => ({
            id: setAside.setAside,
            label: setAside.setAside,
            value: Math.round(setAside.baseAndObligatedTotals),
        }))
    }

    return <BaseTopGraph data={serializeData()}/>;
}

export default ContractsTopSetAsideGraph;